import { render, staticRenderFns } from "./InvoiceSendDialog.vue?vue&type=template&id=6e2b8535"
import script from "./InvoiceSendDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceSendDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports